import { IKitchenArea } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const kitchenAreaApi = crudEndpointsFactory<IKitchenArea>()('kitchen-areas', 'KitchenAreas');
